import React from 'react';
import CrossIcon from '@shared/assets/icons/cross.svg';
import { View } from '@shared/components/View';
import { MBText, MBTextSize } from '@shared/components/text';
import { MBTouchableIcon } from '../touchable/image';
import { MBTooltip, MBTooltipProps } from './MBTooltip';
import { Styles } from './styles';

type MBTextTooltipProps = Omit<MBTooltipProps, 'children'> & {
  title?: string;
  text: string;
  textSize?: MBTextSize;
  color?: string;
  numberOfLines?: number;
  onClose?: () => void;
};

export function MBTextTooltip({
  title,
  text,
  onClose,
  numberOfLines,
  textSize = 'large',
  color = 'black',
  showArrow = true,
  ...tooltipProps
}: MBTextTooltipProps) {
  return (
    <MBTooltip {...tooltipProps} showArrow={showArrow}>
      <View row fullWidth>
        <View flex>
          <MBText size="large" color={color} bold>
            {title}
          </MBText>
          <MBText size={textSize} color={color} numberOfLines={numberOfLines}>
            {text}
          </MBText>
        </View>
        {!!onClose && (
          <View paddingTop={0.5} paddingLeft={1}>
            <MBTouchableIcon
              color={color}
              onPress={onClose}
              style={Styles.closeIcon}
              source={CrossIcon}
            />
          </View>
        )}
      </View>
    </MBTooltip>
  );
}
